import TileTemplate from "../grid/TileTemplate";
import TileType from "../grid/TileType";
import TileTypeBackground from "../grid/TileTypeBackground";
import { SpecialTileTypes, TileTypeArray } from "../grid/TileTypes";
import BasicSprite from "./BasicSprite";
import Spritesheet from "./Spritesheet";

export default class TileTypeBackgroundSpritesheet extends Spritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     */
    constructor(fileName, spriteSize) {
        super(fileName, spriteSize);

        // Tell the superclass to start loading the image.
        this.loadImage();
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        // The first 4 rows are special: ORE, GOLD, UPGRADES, RUBY

        let row = 4;
    
        this.loadTileType(SpecialTileTypes.SKY, row);
        row++;

        this.loadTileType(SpecialTileTypes.GRASS, row);
        row++;

        this.loadTileType(SpecialTileTypes.DIRT, row);
        row++;

        for (let i = 0; i < TileTypeArray.length; i++) {
            this.loadTileType(TileTypeArray[i], row);
            row++;
        }

        /////////////////////////////////////
        // Mark the spritesheet as loaded.
        /////////////////////////////////////

        this.loaded = true;
    }

    /**
     * @private
     * @param {TileType} tileType 
     * @param {number} row 
     */
    loadTileType(tileType, row) {
        tileType.tileTypeBackground = this.parseRow(row);
    }

    /**
     * @private
     * @param {TileType} tileType 
     * @param {number} x
     * @param {number} row 
     * @returns {TileTemplate}
     */
    parseRow(row) {
        const step = this.spriteSize + 1; // There is a 1px buffer between the sprites, only on the bottom and right edges.

        const numSpritesPerRow = 48; 

        const y = row * step;
        let x = 0;

        const tileTypeBackground = new TileTypeBackground();

        for (let i = 0; i < numSpritesPerRow; i++) {
            tileTypeBackground.sprites.push(new BasicSprite(this, x, y));
            x += step;
        }

        return tileTypeBackground;
    }
    
}